module.exports = __webpack_public_path__ + "static/img/act_banner.86b461d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/act_banner.jpg
// module id = mi1i
// module chunks = 37